import React, { useEffect } from "react";
import { useState } from "react";
import { updatePlayerAttribute } from "../firebase/fireFuncs";
import useDetailedBoxTypeModal from "../hooks/useDetailedBoxTypeModal";
import { objectToArray } from "../misc/helperfuncs";
import MainStore from "../stores/MainStore";
import BoxTypeHolder from "./BoxTypeHolder";

const LocalBoxTypesList = ({ onDelete }) => {
  const { player } = MainStore();
  const [boxTypes, setBoxTypes] = useState([]);
  const [selectedBoxType, setSelectedBoxType] = useState(null);
  const modal = useDetailedBoxTypeModal({
    firstTime: false,
    boxType: selectedBoxType,
    setBoxType: setSelectedBoxType,
  });

  useEffect(() => {
    if (selectedBoxType) modal.open();
  }, [selectedBoxType]);

  useEffect(() => {
    setBoxTypes(objectToArray(player.boxTypes));
  }, [player.boxTypes]);

  function openBoxType(boxType) {
    setSelectedBoxType(boxType);
  }

  return (
    <div className="divColumn" style={{ width: "52%" }}>
      <div
        className="textBoldWhite"
        style={{
          fontSize: "20px",
          width: "100%",
          minWidth: "800px",
          backgroundColor: "#4f4f4f",
          textAlign: "center",
        }}
      >
        Your Boxtypes
      </div>
      <div className="divColumn" style={{ width: "100%" }}>
        {boxTypes.map((boxType, index) => (
          <BoxTypeHolder
            boxType={boxType.value}
            key={index}
            playerBoxtypes={objectToArray(player.boxTypes)}
            onClick={openBoxType}
            onDelete={onDelete}
          />
        ))}
      </div>
      {modal.divs}
    </div>
  );
};

export default LocalBoxTypesList;
